module.exports = __webpack_public_path__ + "h5/img/tipswithwords.810e44c7.png";